<template>
  <td>
    {{ model.read_by }} <br />
    <span v-html="readAt"></span>
  </td>
</template>

<script>
import { getDateTimeHtml } from "@/js/date";

export default {
  props: ["model"],
  computed: {
    readAt() {
      return getDateTimeHtml(this.model.read_at);
    }
  }
};
</script>
